import { Dispatch, SetStateAction } from 'react';
import { ConfirmDeleteModal } from '../../../../components/ConfirmDeleteModal/ConfirmDeleteModal';

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  onDeleteStage: () => void;
}

export const DeleteStageModal = ({ isModalOpen, setIsModalOpen, onDeleteStage }: Props) => {
  return (
    <ConfirmDeleteModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      title='Delete the stage?'
      onConfirm={onDeleteStage}
      note='All steps inside will be lost.'
      confirmLabel='Yes, delete'
      cancelLabel='No, cancel'
    />
  );
};
